import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Loder from "../../components/loder";

const PdfViewer = () => {

    const doc = JSON.parse(localStorage.getItem("SESSION_DOC"));

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div className="pdf-viewer container pb-4">
        <div className="card mx-auto my-auto">
        <Document
        file={doc}
        //"https://clapngobucket.s3.amazonaws.com/documents/learner/Demo+Session+Document_compressed.pdf"
        onLoadSuccess={onDocumentLoadSuccess}
        renderAnnotationLayer={true}
        loading={<div className="m-5">
        <Loder />
      </div>}
        noData={<h1>No data</h1>}
        error={<h1>Failed to load PDF file.</h1>}
        onLoadError={<h1>Not able to load</h1>}
        pageIndex={pageNumber}
      >
        <Page pageNumber={pageNumber} />
      </Document>
      <div className="d-flex justify-content-center mb-4" style={{zIndex:1}}>
        <button
        className="m-3"
          onClick={() => {
            if (pageNumber > 1) setPageNumber(pageNumber - 1);
          }}
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        <p className="m-3">
          Page No<br/>
          {pageNumber}/{numPages}
        </p>
        <button
        className="m-3"
          onClick={() => {
            if (pageNumber < numPages) setPageNumber(pageNumber + 1);
          }}
        >
          <i className="fas fa-arrow-right"></i>
        </button>
      </div>
   
        </div>

    </div>
  );
};

export default PdfViewer;
